import { useSelector } from "react-redux";
import { selectComplaint } from "../redux/selectors";
import { userAuthService } from "../auth/UserAuthService";
export const useAuthorizationRoleOnly = (...requestedRoles) => {
    return userAuthService.getRoles().some(userRole => requestedRoles.includes(userRole));
};
export const useAuthorizationForCase = (caseId, ...requestedRoles) => {
    var caseState = useSelector(selectComplaint);
    return !!(caseId &&
        caseState.roles &&
        caseState.roles.caseId === caseId &&
        caseState.roles.roles.some(caseRole => requestedRoles.includes(caseRole.roleType)));
};
